import React, { useEffect, useState } from "react";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Contributor from "../../atoms/Contributor";
import PublishedAt from "../../atoms/PublishedAt";

import { getAuthorName } from "../../utils/utils";
import { getAuthorObj } from "../../helper/api";

import "./storyMetaData.m.css";

const StoryMetaData = ({ story, isAuthor, isTag, isPublished }) => {
  const tagObj = isTag ? get(story, ["tags", "0"], null) : null; // If tag required then try to fetch
  const authorName = getAuthorName(story);

  const showLiveBlog = story["story-template"] === "live-blog";
  const isClosed = get(story, ["metadata", "is-closed"], false);

  const [authorObj, setAuthorObj] = useState({});

  const firstAuthor = isAuthor && get(story, ["authors", "0"], null); // If author required then try to fetch

  const fetchAuthorObj = async (authorId) => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setAuthorObj(data);
    }
  };

  useEffect(() => {
    if (isAuthor) {
      fetchAuthorObj(firstAuthor.id);
    }
  }, []);

  return (
    <div>
      {isAuthor && authorObj && (
        <div styleName="story-meta-data" className="story-meta-data">
          <Contributor
            name={authorName}
            contributorType={5}
            slug={`/author/${authorObj.slug}`}
            className="contributor"
            authorObj={authorObj}
          />
        </div>
      )}
      {tagObj && (
        <div styleName="story-meta-data" className="story-meta-data">
          <Link aria-label={tagObj.name} href={`/topic/${tagObj.slug}`} className="tag-name">
            {tagObj.name}
          </Link>
        </div>
      )}
      {isPublished &&
        (!isClosed && showLiveBlog ? null : (
          <div styleName="story-meta-data" className="story-meta-data">
            <PublishedAt date={story["last-published-at"]} className="published-time" />
          </div>
        ))}
    </div>
  );
};

StoryMetaData.defaultProps = {
  isAuthor: false,
  isTag: false,
  isPublished: true,
};

StoryMetaData.propTypes = {
  story: object.isRequired,
  isTag: bool,
  isAuthor: bool,
  isPublished: bool,
  pageType: string,
};

export default StoryMetaData;
